import { render } from "./BuyerProposalHost.vue?vue&type=template&id=0e99e94c"
import script from "./BuyerProposalHost.vue?vue&type=script&lang=ts"
export * from "./BuyerProposalHost.vue?vue&type=script&lang=ts"
script.render = render

export default script